import { useEffect } from 'react';
import { useConfirm } from './ConfirmationService';
import { useFeatures } from '../backstage/useFeatures';

export const ConfirmationOnCloseManager = () => {
  const { confirmationMessage, needed } = useConfirm(state => ({
    confirmationMessage: state.confirmationMessage,
    needed: state.confirmationNeeded
  }));

  // Disable this feature when developing locally.
  // This is because local builds need to rebuild and refresh very often, and the constant popups get annoying.
  const isDebug = useFeatures('localBuild');

  useEffect(() => {
    if (!needed || isDebug) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = confirmationMessage;
    };
    window.addEventListener('beforeunload', handler);

    return () => {
      window.removeEventListener('beforeunload', handler);
    };
  }, [needed, confirmationMessage]);

  return null;
};
